import { type FC } from 'react';

import { ListingLayout } from '../ListingLayout';
import { SkeletonRect } from '../SkeletonRect';

import styles from './ListingLoadingView.css';

export const ListingLoadingView: FC<{ isNarrow: boolean }> = ({ isNarrow }) => {
  return (
    <ListingLayout
      isFetching
      banners={null}
      cards={null}
      isNarrow={isNarrow}
      navigation={<SkeletonRect height={20} width="50%" />}
      pagination={null}
      renderNoCards={(): JSX.Element => <div />}
      seo={
        <div className={styles['seo']}>
          <SkeletonRect height={36} />
          <SkeletonRect height={36} />
        </div>
      }
      similarCards={null}
    />
  );
};
